// src/utils/aesEncryptor2.js
import CryptoJS from 'crypto-js';

function processEncryptionKey(secret) {
  const utf8Secret = CryptoJS.enc.Utf8.parse(secret);
  const baseHash = CryptoJS.SHA1(utf8Secret);

  const buffer = new Uint8Array(64).fill(0x36);
  for (let i = 0; i < 20; i++) {
    buffer[i] ^= ((baseHash.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff);
  }

  const finalHash = CryptoJS.SHA1(CryptoJS.lib.WordArray.create(buffer));
  const keyBytes = finalHash.clone().words.slice(0, 4); // 4 words = 16 bytes
  return CryptoJS.lib.WordArray.create(keyBytes, 16);
}

export function encrypt(text, secret) {
  try {
    const key = processEncryptionKey(secret);
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
}

export function decrypt(cipherText, secret) {
  try {
    const key = processEncryptionKey(secret);
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}

export function getUnixTimestamp() {
  return Date.now();
}

export function generateObservationURL(deviceid, secretKey) {
  const timestamp = getUnixTimestamp();
  const query = `device_id=${deviceid}&link_creation_time=${timestamp}`;
  const encrypted = encrypt(query, secretKey);
  return `https://iobepicmonitor.caregility.net/e8StCA/${encodeURIComponent(encrypted)}`;
}
